export default __webpack_public_path__ + "static/assets/7e446ef59ca1ca9197f846050a7f5bca.gif";